module.exports = __webpack_public_path__ + "img/Ulta_bottom_left.43374e5c.jpg";